import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.square_order,
    props.app.buttons.create_square_order,
    (order, button) => {
        return {
            order,
            button
        }
    }
)